// extracted by mini-css-extract-plugin
module.exports = {"modal":"GameOver_modal_3O8Wc","title":"GameOver_title_2cUZa","message":"GameOver_message_1hEJ0","button":"GameOver_button_1KiGw","icon":"GameOver_icon_M5bw0"};